<div class="add-person-dialog__root">
  <h1 mat-dialog-title class="headline">New {{ subjectLabel }}</h1>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input
          type="text"
          matInput
          inputmode="text"
          placeholder="e.g., John Doe"
          formControlName="name"
        />
        @if (name.invalid) {
          <mat-error>{{ getNameErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Phone Number</mat-label>
        <input
          matInput
          type="text"
          inputmode="tel"
          placeholder="e.g., (530) 334-5540"
          (keyup)="handleKeyUp($event)"
          formControlName="phone"
        />
        @if (phone.invalid) {
          <mat-error>
            {{ getPhoneErrorMessage() }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Callback location</mat-label>
        <mat-select formControlName="location" placeholder="Select a callback location" required>
          @for (l of locations; track $index) {
            <mat-option [value]="l">
              {{ l.name }}
            </mat-option>
          }
        </mat-select>
        @if (form.controls.location.hasError('required')) {
          <mat-error>Select a callback location</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>DISCARD</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">
      ADD
    </button>
  </mat-dialog-actions>
</div>
